import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import posed from 'react-pose';

import styles from './styles.module.css';

const transition = {
    duration: 200,
    ease: 'easeInOut',
};

const Switch = posed.div({
    preEnter: {
        opacity: 0,
    },
    enter: {
        opacity: 1,
        transition,
    },
    exit: {
        opacity: 0,
        transition,
    },
});

const TextSwitch = ({
    label, checked, onSelect, value,
}) => (
    <Switch
        key="switch"
        className={classnames(styles.container, {[styles.checked]: checked})}
        onClick={(evt) => onSelect(value, evt)}
        onKeyDown={(evt) => (evt.keyCode === 13 || evt.keyCode === 32) && onSelect(value, evt)}
        tabIndex="0"
        role="checkbox"
        aria-checked={checked}
    >
        <span>{label}</span>
    </Switch>
);

TextSwitch.propTypes = {
    label: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool,
};

TextSwitch.defaultProps = {
    checked: false,
};

export default TextSwitch;
